import React from 'react';
import ButtonAppNew from 'components/ButtonAppNew';
import EmailIcon from '@material-ui/icons/Email';
import { getMailtoUrl } from 'utils';

const getUsername = user => {
  if (user.first_name && user.last_name) return `${user.first_name} ${user.last_name}`;
  if (!user.first_name && user.last_name) return user.last_name;
  if (user.first_name && !user.last_name) return user.first_name;
  return user.email;
};

const InvitationButton = ({
  script,
  user,
}) => {
  const username = getUsername(user);
  const topic = `${username}'s Iteriodata Invitation`;
  const body = `${username} invited you to implement iteriodata snippet.

  Copy and paste this code as the first item into the <HEAD> of every webpage you want to track:

  ${script}
`.replace(/[\r\t\f\v ]+[\r\t\f\v ]/mg, '');

  const mailto = getMailtoUrl('', topic, body);

  return (
    <ButtonAppNew
      component="a"
      variant="outlined"
      href={mailto}
    >
      <EmailIcon />
      Email to a teammate
    </ButtonAppNew>
  );
};

export default InvitationButton;



// WEBPACK FOOTER //
// ./src/components/common/accounts/components/JsDialog/InvitationButton/InvitationButton.js